export default (props) => {
	const { header, title, url, showInTabletAndMobile } = props;
	return {
		header,
		title,
		url,
		showInTabletAndMobile: showInTabletAndMobile.value,
	};
};
